<script>
import Api from '@/components/Api/Api'
import Vue from 'vue'
let ProductoModel = new Vue({
  name: 'ProductoModel',
  methods: {
    async lista(forzar) {
      forzar = forzar && true
      let productos
      let localStorageKeys = Object.keys(localStorage)
        .filter(u => u.startsWith('hb3.producto.'))
      try {
        productos = []
        for (let key in localStorage) {
          if (key.startsWith('hb3.producto.'))
            productos.push(Api.fetchLocal(key))
        }
        if (productos.length == 0)
          throw new Error('Caché vacía')
        if (forzar)
          throw new Error('Descarga de lista completa forzada')
      } catch (e) {
        if (typeof e != 'string')
          console.warn("EPRODS", e)
        try {
          productos = await Api.get('producto')
        } catch (e) {}
        for (let p of productos)
          if (p && p._id) {
            let label = 'hb3.producto.' + p._id
            if (localStorageKeys.indexOf(label) == -1 || forzar == true)
              Api.saveLocal(label, p)
          }
      }
      productos = productos.sort((a, b) => {
        return a.nombre > b.nombre ? 1 : -1
      })
      // Si no se ha guardado el producto con la nueva versión, implementar la empresa
      let empresa = Api.fetchLocal('hb3.empresadb') || {}
      let idEmpresa = empresa._id
      let productosEnEmpresa = false
      for (let e of productos)
        if (e.idEmpresa && (e.idEmpresa == idEmpresa || e.idEmpresa == ''))
          productosEnEmpresa = true
      if (!productosEnEmpresa)
        productos = productos.map(p => {
          p.idEmpresa = idEmpresa
          return p
        })
      return new Promise((resolve) => {
        console.log("Productos lista", productos.length)
        resolve(productos)
      })
    },
    async familias(forzar) {
      forzar = forzar && true
      let familias
      try {
        familias = []
        for (let key in localStorage) {
          if (key.startsWith('hb3.familia.'))
            familias.push(Api.fetchLocal(key))
        }
        if (familias.length == 0)
          throw new Error('Caché vacía')
        if (forzar)
          throw new Error('Descarga de lista completa forzada')
      } catch (e) {
        if (typeof e != 'string')
          console.warn("EFAMS", e)
        try {
          familias = await Api.get('familia')
        } catch (e) {}
        for (let p of familias)
          if (p && p._id) {
            Api.saveLocal('hb3.familia.' + p._id, p)
          }
      }
      familias = familias.sort((a, b) => {
        return a.nombre > b.nombre ? 1 : -1
      })
      return new Promise((resolve) => {
        console.log("Productos lista", familias.length)
        resolve(familias)
      })

    },
    ver(id) {
      id = id || ''
      if (id == '')
        return Promise.reject('Producto no especificado')
      else
        return new Promise(async (resolve, reject) => {
          let s
          if (id && id.length == 24) {
            try {
              let n = Api.fetchLocal('hb3.producto.' + id)
              if (n && n._id)
                s = n
              else
                throw new Error('Producto no en caché ' + id)
            } catch (e) {
              s = await Api.get('producto', id)
            }
          } else {
            try {
              s = await Api.find('producto', ['clave,cs,' + id])
            } catch (e) {
              throw new Error('Producto no encontrado por clave')
              console.error(e)
            }
          }
          let producto = null
          if (id && id.length == 24)
            producto = s
          else
            producto = s[0]
          // variantes de etiquetas
          if (!producto.variante1etiqueta)
            producto.variante1etiqueta = []
          if (!producto.variante2etiqueta)
            producto.variante2etiqueta = []
          //
          if (producto && producto._id) {
            Api.saveLocal('hb3.producto.' + producto._id, producto)
            resolve(producto)
          } else reject({
            error: 'No se pudo encontrar el producto'
          })
        })
    },
    tieneVariantes(id) {
      let prod = Api.fetchLocal('hb3.producto.' + id)
      let variantes1 = (prod.variante1 || []).length
      let variantes2 = (prod.variante2 || []).length
      return (variantes1 * variantes2) > 1
    },
    async obtenerListaVariantes(id, prod) {
      id = id || ''
      prod = prod || {}
      let variantes = []
      try {
        //if (!prod._id ||true)
        prod = await Api.get('producto', id)
        if (prod.variante1 && prod.variante1.length > 0 &&
          prod.variante2 && prod.variante2.length > 0)
          for (let var1 of prod.variante1)
            for (let var2 of prod.variante2)
              variantes.push('' + var2 + ',' + var1)
      } catch (e) {
        console.error("No encontradas variantes", e)
      }
      console.log("Variantes encontradas", prod.variante1, prod.variante2, prod.codigo, variantes)
      return Promise.resolve(variantes)
    },
    async guardar(prod) {
      try {
        let s = await Api.save('producto', prod)
        if (prod._id)
          Api.saveLocal('hb3.producto.' + prod._id, prod)
        else if (s._id)
          Api.saveLocal('hb3.producto.' + s._id, s)
        return new Promise((resolve) => {
          resolve(prod._id || s._id)
        })
      } catch (e) {
        return new Promise((resolve, reject) => {
          reject({
            error: 'Producto no guardado',
            raw: e
          })
        })
      }
    },
    obtener(id) {
      return ProductoModel.ver(id)
    },
    obtenerCosto(producto, variante) {
      return this.obtenerPrecio(producto, 'costo', variante)
    },
    obtenerPrecio(producto, set, variante) {
      set = set || ''
      variante = variante || ''
      //if (variante && variante.length > 0) variante = variante.split('_')[1]
      switch (set) {
        case 1:
        case '1':
        case 2:
        case '2':
        case '3':
        case 4:
        case '4':
        case 5:
        case '5':
          set = 'precio' + set
          break;
        case 'costo':
          break;
        default:
          set = 'precio1'
          break;
      }
      if (variante != '')
        console.log("Obteniendo precio de variante?", (producto || {}).nombre, set, variante)
      if (typeof producto != 'object') {
        return 0
      } else {
        let pr = producto[set]
        if (
          set != '' &&
          variante != '' &&
          producto &&
          producto.setCostos &&
          producto.setCostos[set] &&
          producto.setCostos[set][variante]
        ) {
          pr = producto.setCostos[set][variante]
        }
        /*/ Iva
        if (producto.iva && producto.iva != 0) {
          let factor = 1 + (producto.iva / 100)
          pr *= factor
        }
        //*/
        console.log("Obtenido precio", set, variante, producto.nombre, producto.iva, pr)
        return pr
      }
    },
    obtenerIva(precioUnitario, producto) {
      precioUnitario = precioUnitario || 0
      producto = producto || {}
      let iva = producto.iva || 0
      let pr = precioUnitario * (iva / 100)
      console.log("Obtenido IVA", producto.nombre, precioUnitario, iva, pr)
      return pr
    },
    obtenerVarianteDesdeCodigo(prod, codigo) {
      prod = prod || {}
      codigo = codigo || ''
      let variante = ''
      try {
        codigo = codigo.split('-')[1]
        for (let et1 in prod.variante1etiqueta)
          for (let et2 in prod.variante2etiqueta)
            if ((prod.variante2etiqueta[et2] + prod.variante1etiqueta[et1]).toLowerCase() == codigo)
              variante = prod.variante2[et2] + ',' + prod.variante1[et1]
        console.log("Variante encontrada?", prod.clave, codigo, variante)
      } catch (e) {
        return Promise.reject({
          error: 'No se pudo obtener la variante desde el código ' + codigo,
          raw: e
        })
      }
      return variante
    }
  },
  async created() {
    console.log("ProductoModel created")
    let familias = await Api.get('familia')
    if (familias.length == 0) {
      let familia = {
        nombre: 'Default',
        default: true
      }
      await Api.save('familia', familia)
      // alert2('Se ha creado una familia predeterminada')
    }
  }
})
export default ProductoModel
</script>
